// extracted by mini-css-extract-plugin
export var alternate = "_r-j";
export var black = "_r-6";
export var blue = "_r-f";
export var blueLight = "_r-e";
export var brand = "_r-8";
export var darkMode = "_r-b";
export var error = "_r-a";
export var gray = "_r-5";
export var grayBlue = "_r-d";
export var iconWrapper = "_r-3";
export var inactive = "_r-7";
export var indigo = "_r-g";
export var orange = "_r-i";
export var pink = "_r-h";
export var primary = "_r-0";
export var purple = "_r-9";
export var success = "_r-4";
export var warning = "_r-c";
export var white = "_r-1";
export var whiteSuccess = "_r-2";